import axios from 'axios'

export const axiosClient = axios.create({
  baseURL: import.meta.env['VITE_BASE_URL'],
  headers: {
    'Content-Type': 'application/json',
  },
})

export function storeToken(token: string) {
  axiosClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
  localStorage.setItem('jwt_token', token)
}

export function getToken(): string | null {
  return localStorage.getItem('jwt_token')
}

export function validateSession(): boolean {
  const token = localStorage.getItem('jwt_token')

  if (token) {
    axiosClient.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return true
  }

  return false
}
